import styled from 'styled-components';

export const SummaryContainer = styled.div`
  margin-top: 32px;
  padding-bottom: 30px;
`;

export const SummaryBox = styled.div`
  background: #ededed;
  padding: 25px 20px 20px 20px;
  border-radius: 0;
  position: relative;
  padding-bottom: 30px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  clip-path: polygon(
    0 10px,
    3% 5px,
    7% 12px,
    12% 8px,
    18% 15px,
    25% 7px,
    32% 13px,
    38% 6px,
    45% 11px,
    52% 8px,
    58% 14px,
    65% 9px,
    72% 13px,
    78% 7px,
    85% 12px,
    92% 8px,
    97% 11px,
    100% 9px,
    100% 100%,
    0 100%
  );

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 10px;
    background-image: radial-gradient(
      circle at 10px 10px,
      white 10px,
      #ededed 10px
    );
    background-size: 20px 20px;
    background-position: 0 0;
    background-repeat: repeat-x;
    z-index: 1;
  }
`;

export const SummaryItem = styled.div`
  background: white;
  padding: 12px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: #4b5563;
`;

export const Divider = styled.div`
  border-top: 2px solid #ccc;
  margin: 16px 0;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  color: #000;
`;
